import axios from 'axios'

const FACE_API_BASE = '/api/intelli/face'

class FaceSearchService {
  constructor() {
    if (typeof FaceSearchService.instace === 'object') return FaceSearchService.instace
    FaceSearchService.instace = this
    this.consultaMurphy = null
    this.consultaMurphyLoaded = false
  }

  // POST multipart /api/intelli/face/faces/search
  // - params: { mode, city?, lat?, lng?, radius_m?, start_date, end_date,
  //            min_detection_similarity, limit, offset }
  // - photo: File
  // - signal: AbortSignal opcional
  async search({ photo, params, signal }) {
    const formData = new FormData()
    formData.append('image', photo)
    const response = await axios.post(
      `${FACE_API_BASE}/faces/search`,
      formData,
      { params, signal }
    )
    return response.data || { results: [], total: 0 }
  }

  // POST multipart /api/intelli/face/faces/enrich
  // - identifier: consultaMurphy string
  // - photo: File
  async enrich({ identifier, photo, signal }) {
    const formData = new FormData()
    formData.append('identifier', identifier)
    formData.append('data', photo)
    const response = await axios.post(
      `${FACE_API_BASE}/faces/enrich`,
      formData,
      { signal }
    )
    return response.data || null
  }

  // Lee /api/session y extrae user.consultaMurphy
  async loadConsultaMurphy() {
    if (this.consultaMurphyLoaded && this.consultaMurphy) return this.consultaMurphy
    try {
      const res = await axios.get('/api/session')
      const user = res && res.data
      const attrs = user && user.attributes
      this.consultaMurphy = (attrs && (attrs.consulta_murphy || attrs.consultaMurphy)) || null
    } catch (err) {
      this.consultaMurphy = null
    }
    this.consultaMurphyLoaded = true
    return this.consultaMurphy
  }

  // Normaliza URLs absolutas y relativas devueltas por el backend FR.
  // - URLs absolutas que contienen "/uploads/" se reescriben a "/api/intelli/face/uploads/"
  // - URLs relativas se prefijan con "/api/intelli/face/"
  resolveImageUrl(raw) {
    if (!raw || typeof raw !== 'string') return ''
    if (raw.startsWith('http://') || raw.startsWith('https://')) {
      const m = raw.match(/^(.*)\/uploads\/(.+)$/)
      if (m) return raw.replace('/uploads/', `${FACE_API_BASE}/uploads/`)
      return raw
    }
    if (raw.startsWith('/uploads/')) return raw.replace('/uploads/', `${FACE_API_BASE}/uploads/`)
    if (raw.startsWith('/')) return raw
    return `${FACE_API_BASE}/${raw}`
  }

  // Mapea errores HTTP a códigos consumibles por la UI.
  classifyError(err) {
    if (axios.isCancel(err) || (err && err.name === 'CanceledError')) return 'cancelled'
    const status = err && err.response && err.response.status
    if (status === 401) return 'session_expired'
    if (status === 413) return 'file_too_large'
    if (status === 422) {
      const code = err.response.data && err.response.data.code
      if (code === 'no_face_in_image') return 'no_face'
    }
    if (status === 400) return 'bad_request'
    if (status === 404 || status === 502 || status === 503) return 'unavailable'
    if (!status) return 'network'
    return 'unavailable'
  }

  extractBackendMessage(err) {
    const data = err && err.response && err.response.data
    if (!data) return ''
    return data.message || data.error || ''
  }
}

export default new FaceSearchService()
export { FaceSearchService }
